import { render, staticRenderFns } from "./FlipDown.vue?vue&type=template&id=0d5de546"
import script from "./FlipDown.vue?vue&type=script&lang=js"
export * from "./FlipDown.vue?vue&type=script&lang=js"
import style0 from "./FlipDown.vue?vue&type=style&index=0&id=0d5de546&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports